export const onChange = ({ setSelected, selectedOptions }) => {
  setSelected(
    (Array.isArray(selectedOptions)
      ? selectedOptions
      : [selectedOptions]
    ).filter(value => Boolean(value))
  );
};
